import { useState } from "react";
import { TOKEN } from "../api/constants";

export default function useToken() {
  const getToken = () => {
    const tokenString = localStorage.getItem(TOKEN);

    return tokenString;
  };

  const [token, setToken] = useState(getToken());

  const saveToken = (userToken) => {
    localStorage.setItem(TOKEN, userToken);
    setToken(userToken);
  };

  return {
    setToken: saveToken,
    token,
  };
}
